export default __webpack_public_path__ + "static/media/1663363038452.b76287bb.jfif";